// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateDraftParameter";
import { useShipmentHistoryState } from "@store/Framework/Store/Greif/Pages/ShipmentHistory/ShipmentHistoryHooks";
import { getShipmentStatusesDataView } from "@store/Framework/Store/Greif/Data/ShipmentStatuses/ShipmentStatusesSelectors";
import { ShipmentStatusModel } from "@store/Framework/Types/ApiModels";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import React, { FC, useMemo } from "react";

const ShipmentHistoryFilterFieldStatus: FC = () => {
    const dispatch = useAppDispatch();
    const { deliveryStatuses } = useShipmentHistoryState().draftParameter;
    const shipmentStatusMappingsDataView = useAppSelector(state => getShipmentStatusesDataView(state));
    const id = useMemo(uniqueId, []);
    const statuses: ShipmentStatusModel[] = shipmentStatusMappingsDataView?.value || [];

    const handleChange = (statusName: string, checked: boolean) => {
        const currentStatuses = deliveryStatuses || [];
        let nextStatuses: string[];

        if (checked) {
            nextStatuses = [...currentStatuses, statusName];
        } else {
            nextStatuses = currentStatuses.filter(s => s !== statusName);
        }

        dispatch(updateDraftParameter({ deliveryStatuses: nextStatuses }));
    };

    return (
        <FilterDrawerSection
            title={translate("Shipment Status")}
            modalTitle={translate("Shipment Status Descriptions")}
            isAccordion={true}
            modalText={siteMessage("ShipmentHistory_ShipmentStatusDescriptions")}
        >
            <CheckboxGroup>
                {statuses.map(status => (
                    <Checkbox
                        key={status.name}
                        checked={deliveryStatuses?.includes(status.name) ?? false}
                        onChange={(_, value) => handleChange(status.name, value)}
                        data-test-selector={`shipmentHistory_filterStatus_${status.name}`}
                    >
                        {status.description || status.name}
                    </Checkbox>
                ))}
            </CheckboxGroup>
        </FilterDrawerSection>
    );
};

export default ShipmentHistoryFilterFieldStatus;
